import React from 'react';
import { PhoneIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-charcoal text-alabaster/70 py-1 px-6 border-b border-white/10 text-[10px] md:text-xs font-bold uppercase tracking-[0.15em]" data-id="element-172">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-173">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-174">
          <div className="flex items-center gap-2" data-id="element-175">
            <ShieldCheckIcon className="w-3 h-3 text-espresso" data-id="element-176" />
            <span data-id="element-177">Fully Licensed & Insured</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-178">
            <AwardIcon className="w-3 h-3 text-espresso" data-id="element-179" />
            <span data-id="element-180">MHIC #123456 • VA Class A</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-181">
            <span className="text-espresso" data-id="element-182">●</span>
            <span data-id="element-183">$2M General Liability Coverage</span>
          </div>
        </div>
        <div className="flex items-center gap-2 text-alabaster" data-id="element-184">
          <PhoneIcon className="w-3 h-3 text-espresso" data-id="element-185" />
          <a href="tel:3015550123" className="hover:text-espresso transition-colors" data-id="element-186">
            (301) 555-0123
          </a>
        </div>
      </div>
    </div>;
}